module.exports = __webpack_public_path__ + "img/bg-nosotros-3.758b049f.png";